// src/store/slices/creditSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchOrganizationPlan } from '@/services/creditService';
import { OrganizationPlan } from '@/models/Credits';

interface CreditState {
    plan: OrganizationPlan | null;
    usageByType: { [key: string]: number } | null;
    loading: boolean;
    error: string | null;
}

const initialState: CreditState = {
    plan: null,
    usageByType: null,
    loading: false,
    error: null,
};

export const fetchCreditData = createAsyncThunk(
    'credits/fetchCreditData',
    async (_, { rejectWithValue }) => {
        try {
            const [plan] = await Promise.all([
                fetchOrganizationPlan(),
            ]);
            return { plan };
        } catch (error) {
            return rejectWithValue('Failed to fetch credit data');
        }
    }
);

const creditSlice = createSlice({
    name: 'credits',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCreditData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCreditData.fulfilled, (state, action: PayloadAction<{
                plan: OrganizationPlan;
            }>) => {
                state.loading = false;
                state.plan = action.payload.plan;
            })
            .addCase(fetchCreditData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default creditSlice.reducer;
export type { CreditState };